export { default as ProductsIndexPageCategoriesNav } from './ProductsIndexPageCategoriesNav';
